import React from 'react';
import { 
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Typography
} from '@mui/material';

interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <MuiBreadcrumbs sx={{ mb: 2 }}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const hasHref = item.href !== undefined;
        const hasOnClick = item.onClick !== undefined;
        
        // If item has href, make it a Link (even if it's the last item)
        if (hasHref) {
          return (
            <Link 
              key={item.label}
              href={item.href} 
              variant="body1"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'text.primary', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 400, '&:hover': { textDecoration: 'underline' }, cursor: 'pointer' }}
            >
              {item.label}
            </Link>
          );
        }
        
        // If item has onClick, make it a clickable Link
        if (hasOnClick) {
          return (
            <Link 
              key={item.label}
              component="button"
              variant="body1"
              onClick={item.onClick}
              sx={{ color: 'text.primary', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 400, '&:hover': { textDecoration: 'underline' }, cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
            >
              {item.label}
            </Link>
          );
        }
        
        // Otherwise, use Typography for last item, Link for others
        return isLast ? (
          <Typography key={item.label} variant="body1" sx={{ color: 'text.primary', fontSize: '1.1rem', fontWeight: 400 }}>
            {item.label}
          </Typography>
        ) : (
          <Link 
            key={item.label}
            href={item.href ?? '#'} 
            variant="body1"
            sx={{ color: 'text.primary', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 400, '&:hover': { textDecoration: 'underline' } }}
          >
            {item.label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;